import { FC, useEffect } from "react";

const AuthSuccess: FC = () => {
  useEffect(() => {
    setTimeout(() => {
      window.close();
    }, 1000);
  }, []);
  return (
    <div className="container mb-24 lg:mb-32">
      <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
        Berhasil Terauthentikasi
      </h2>
    </div>
  );
};

export default AuthSuccess;
